module.exports = __webpack_public_path__ + "static/media/4540.1fb36e6d.jpg";